import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Container, Grid, Button } from "@mui/material";

import Logo from "../assets/img/logo.svg";

import { NavigationComponent } from "./navigation";

import { TokenAuth } from "../modules/token";

import { useAppSelector, useAppDispatch } from "../redux/hooks";
import { getApp, logout, setSid } from "../redux/app.slice";

import { AttendanceReportComponent } from "./attendance-report";

export const DashboardComponent = () => {
  const navigate = useNavigate();
  const app = useAppSelector(getApp);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (app.student && app.token) {
      TokenAuth(app.student, app.token)
        .then((response) => {
          dispatch(setSid(response.data.sid));
        })
        .catch((error) => {
          dispatch(logout());
          navigate("/");
        });
    }
  }, [navigate, app.student, app.token, dispatch]);

  useEffect(() => {
    if (!app.isLoggedIn) navigate("/");
  }, [app.isLoggedIn, navigate]);

  return (
    <>
      <NavigationComponent />
      <Container maxWidth="sm" style={{ margin: "2em auto" }}>
        <Stack spacing={3}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ marginBottom: "1em" }}
          >
            {/**<img
              src={Logo}
              width={100}
              alt="London School of Commerce Group of Colleges Logo"
  />**/}
          </Grid>
          {app.student ? (
            <Button>
              Hello {app.student.first_name} {app.student.last_name}! (
              {app.student.sid})
            </Button>
          ) : null}

          <Button
            variant="outlined"
            onClick={() => navigate("/dashboard/attendance")}
          >
            Attendance
          </Button>
          {app.student ? (
            <AttendanceReportComponent secret={app.student.secret} />
          ) : (
            <></>
          )}
        </Stack>
      </Container>
    </>
  );
};
